import AuthDataFormLayout from "../../components/Layout/AuthDataFormLayout";
import ManualDataForm from "../../components/Auth/ManualDataForm";

const ManualData = () => {
  return (
    <AuthDataFormLayout>
      <ManualDataForm />
    </AuthDataFormLayout>
  );
};

export default ManualData;
